import { Product as SchemaProduct } from "schema-dts";

import { BrandDetail, ProductCategory } from "@/custom-types/BrandDetail";
import { Product } from "@/custom-types/Product";
import generateBrandSchema from "@/utils/schemas/generateBrandSchema";

export default (
  brand: BrandDetail,
  category: ProductCategory,
  products: Product[],
  countryCode: string,
  domain: string,
) => {
  const productList = buildProducts(brand, products, countryCode, domain);

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: category.seoName.replace(/./, (m) => m.toUpperCase()),
    url: `${domain}/brands/${brand.slug}/catalog/${category.slug}`,
    ...(productList &&
      productList.length > 0 && { itemListElement: productList }),
  };
};

const buildProducts = (
  brand: BrandDetail,
  products: Product[],
  countryCode: string,
  domain: string,
) => {
  return products.reduce<SchemaProduct[]>(
    (products: SchemaProduct[], product: Product) => {
      if (
        product.countApprovedPublicReviews ||
        product.bestOfferVariant?.price
      ) {
        products.push(buildProductSchema(brand, product, countryCode, domain));
      }
      return products;
    },
    [],
  );
};

const buildProductSchema = (
  brand: BrandDetail,
  product: Product,
  countryCode: string,
  domain: string,
): SchemaProduct => {
  return {
    "@type": "Product",
    ...(product.countApprovedPublicReviews && {
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue:
          product.avgApprovedPublicReviewRating > 0
            ? product.avgApprovedPublicReviewRating
            : undefined,
        reviewCount:
          product.countApprovedPublicReviews > 0
            ? product.countApprovedPublicReviews
            : undefined,
      },
    }),
    brand: generateBrandSchema(brand, domain, false),
    description: product.description,
    image: product.imageUrl,
    name: product.name,
    ...(product?.bestOfferVariant?.price && {
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        price: product?.bestOfferVariant?.price,
        priceCurrency: countryCode === "US" ? "USD" : "CAD",
      },
    }),
  };
};
